import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Repo from "../../Repository/Repo";
import moment from "moment";

const initialState = {
  loading: true,
  error: "",
  expiryDate: null,
  status: null,
};

export const getTrial = createAsyncThunk("trial/fetchtrial", () => {
  return Repo.user({
    request: {
      method: "getUserTrialsDetails",
      data: {
        user: {
          email: localStorage.getItem("email"),
        },
      },
    },
  })
    .then(({ data }) => data.response.data)
    .catch((err) => console.log(err));
});

export const trialSlice = createSlice({
  name: "trial",
  initialState,
  reducers: {
    addTrial: (state, action) => {
      const { expiryDate, isTrial } = action.payload;
      state.expiryDate = expiryDate;
    },
    handleLoading: (state, action) => {
      state.loading = false;
    },
    clearTrial: (state) => {
      state.expiryDate = null;
    },
    addCountry: (state) => {
      state.country = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTrial.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTrial.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      console.log(action.payload);

      if (action.payload?.isTrial) {
        console.log("trial");
        const { isTrial, trialExpireDate } = action.payload;
        console.log("trialExpireDate:", trialExpireDate);
        let today = moment().format("DD/MM/YY");
        // let newDate = new Date(today);
        // let expiry = new Date(trialExpireDate);
        console.log("today:", today);
        if (today == trialExpireDate || today > trialExpireDate) {
          console.log("if overdue");
          state.status = "Trial Ended";
        } else {
          console.log("Trial is started");
          state.status = "Trial";
          state.expiryDate = action.payload.trialExpireDate;
        }
      } else if (action.payload?.isPaid) {
        state.status = "Paid";
        state.expiryDate = null;
      } else if (!action.payload?.isTrial && !action.payload?.isPaid) {
        // localStorage.clear();
        state.status = "Trial Ended";
      }
    });
    builder.addCase(getTrial.rejected, (state, action) => {
      state.loading = false;
      state.expiryDate = null;
      state.status = null;
      state.error = action.error.message;
    });
  },
});

export const { handleTrial, addTrial, clearTrial, handleLoading ,addCountry} =
  trialSlice.actions;

export default trialSlice.reducer;
